import { Component, OnInit } from '@angular/core';
import { EAppointmentStatus } from 'src/app/shared/interfaces/appointmentStatus-enum';
import { EPaymentStatus } from 'src/app/shared/interfaces/paymentStatus-enum';
import { IVisit } from 'src/app/shared/interfaces/visit';
import { EVisitType } from 'src/app/shared/interfaces/visitType-enum';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-visits',
  templateUrl: './visits.component.html',
  styleUrl: './visits.component.css'
})
export class VisitsComponent implements OnInit {

  visitsList: IVisit[];
  visitType = EVisitType;
  visitStatus = EAppointmentStatus;
  paymentStatus = EPaymentStatus;
  tempVisit: IVisit;
  searchBody = {
      // id: 0,
      title: '',
      pageIndex: 1,
      pageSize: 10,
      type: null,
      status: null,
      paymentStatus: null,
      isAdmin: true
  }

  first: number = 0 ;
  rows: number = 10;
  pageSize = 10;  
  currentpage = 1;
  collectionSize: number = 10;

  constructor(public apiService: ApiService) {}

  ngOnInit(): void {
    this.getAllVisits(0);
  }

  convertUTCMinutesToLocal(utcMinutes: number): number | any {
    // Get the current date (ignoring time) in UTC
    const utcDate = new Date();
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
  
    // Add UTC minutes to the date
    utcDate.setUTCMinutes(utcMinutes);
  
    // Convert to local time
    const localHours = utcDate.getHours(); // Local hours
    const localMinutes = utcDate.getMinutes(); // Local minutes
  
    // Convert local time to total minutes from 00:00 local time
    return this.calculateTime(localHours * 60 + localMinutes);
  }

  getAllVisits(page) {
    this.searchBody = {
      // id: 0,
      title: this.searchBody.title,
      pageIndex: page+1,
      pageSize: 10,
      type: Number(this.searchBody.type),
      status: Number(this.searchBody.status),
      paymentStatus: Number(this.searchBody.paymentStatus),
      isAdmin: true
    }
    this.apiService.apiCall('post', '/api/User/GetAllVisit', this.searchBody).subscribe((res: any) => {
      console.log(res);

      this.visitsList = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })
  }

  calculateTime(time) {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    // Format the time as HH:mm
    const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return timeString
  }

  getFileExtension(fileName: string): string | null {
    return fileName?.includes('.') ? fileName?.split('.').pop() : null;
  }
  
}
